export const removeSubString = (string, toRemoveString) => {
    // Check if the name is present in the title
    const index = string.indexOf(toRemoveString);
    if (index !== -1) {
        const updatedTitle = string.slice(0, index) + string.slice(index + toRemoveString.length);
        return updatedTitle.trim();
    }
    return string;
}